import React from 'react';
import { Search, CheckCircle, Star, Calendar } from 'lucide-react';

const steps = [
  {
    icon: Search,
    title: 'Search for a service',
    description: 'Tell us what you need done and where you are located'
  },
  {
    icon: CheckCircle,
    title: 'Compare verified pros',
    description: 'Review ratings, prices, and profiles of local professionals'
  },
  {
    icon: Calendar,
    title: 'Book instantly',
    description: 'Schedule service at a time that works for you'
  },
  {
    icon: Star,
    title: 'Leave a review',
    description: 'Share your experience to help others in the community'
  }
];

const HowItWorks = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            How Profind.ca Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Getting professional help for your home has never been easier
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-600 text-white rounded-full mb-4 shadow-lg">
                  <step.icon className="h-8 w-8" />
                </div>
                <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center border-4 border-white shadow-md">
                  <span className="text-orange-600 font-bold text-lg">{index + 1}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2 mt-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-orange-300 to-transparent -ml-8"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;